import React, { useContext, useMemo } from 'react';

import { ApiContext } from '_lib/api/apiContext';
import { Location } from '_lib/api/apiTypes.shim';

import { BackdropSpinner } from '_lib/components/BackdropSpinner/BackdropSpinner';
import { Card } from '_lib/components/Card/Card';
import { CardContent } from '_lib/components/CardContent/CardContent';
import { FlexBox } from '_lib/components/FlexBox/FlexBox';
import { Typography } from '_lib/components/Typography/Typography';

import { ContentBox } from '_lib/styles/PhoneCall.styled';

import { MembershipList } from '../MembershipList/MembershipList';

export interface CustomerMembershipsProps {
  locations: Location[];
  companyId: string;
  providerCustomerId: string;
  selectedLocation?: Location;
}

export const CustomerMemberships = (props: CustomerMembershipsProps): React.ReactElement => {
  const { locations, companyId, providerCustomerId, selectedLocation } = props;

  const api = useContext(ApiContext);
  const serviceTitanApi = useMemo(() => api.serviceTitan(companyId), [api, companyId]);
  const customerMembershipResource = useMemo(
    () => serviceTitanApi.customers.memberships(providerCustomerId),
    [providerCustomerId, serviceTitanApi.customers]
  );

  const membershipTypeQuery = serviceTitanApi.membershipTypes.useUnpagedListCached();
  const customerMembershipQuery = customerMembershipResource.useUnpagedListCached();

  const isFetching = membershipTypeQuery.isFetching || customerMembershipQuery.isFetching;

  return (
    <FlexBox sx={{ px: 3, py: 2, flexDirection: 'column' }}>
      {isFetching && (
        <ContentBox>
          <BackdropSpinner open={true} />
        </ContentBox>
      )}
      {!isFetching && (!membershipTypeQuery?.data?.length || !customerMembershipQuery?.data?.length) && (
        <Card variant='outlined'>
          <CardContent>
            <Typography text='No memberships.' />
          </CardContent>
        </Card>
      )}
      {membershipTypeQuery.data &&
        membershipTypeQuery.data.length > 0 &&
        customerMembershipQuery.data &&
        customerMembershipQuery.data.length > 0 && (
          <MembershipList
            memberships={customerMembershipQuery.data}
            membershipTypes={membershipTypeQuery.data}
            locations={locations}
            selectedLocation={selectedLocation}
          />
        )}
    </FlexBox>
  );
};
